<template>
  <div class="flex h-screen bg-background-dark text-text-light">
    <!-- Sidebar -->
    <SidebarComponent />

    <!-- Content -->
    <div class="flex-1 flex flex-col overflow-y-auto">
      <!-- Header -->
      <header class="bg-sidebar-dark text-text-light p-4 flex justify-between items-center shadow-md">
        <h1 class="text-2xl font-bold text-accent-light">Conturi</h1>
      </header>

      <!-- Main Content -->
      <main class="flex-1 p-6 space-y-8">
        <!-- Button pentru creare cont -->
        <div class="flex justify-end">
          <button @click="openCreateModal"
            class="bg-accent-light text-white font-bold py-2 px-4 rounded hover:bg-accent-dark transition">
            Creează Cont
          </button>
        </div>

        <!-- Tabel utilizatori -->
        <div class="overflow-x-auto bg-card-welcome p-4 rounded-lg shadow-md">
          <table class="table-auto w-full text-left border-collapse">
            <thead>
              <tr class="text-text-light border-b border-gray-700">
                <th class="py-2 px-4">Username</th>
                <th class="py-2 px-4">Rol</th>
                <th class="py-2 px-4">Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id" class="hover:bg-hover-dark transition">
                <td class="py-2 px-4">{{ user.username }}</td>
                <td class="py-2 px-4">{{ user.role }}</td>
                <td class="py-2 px-4 space-x-2">
                  <button class="bg-red-500 hover:bg-red-700 text-white font-bold py-1 px-3 rounded transition"
                    @click="deleteUser(user.id)">
                    Șterge
                  </button>
                  <button @click="openChangePasswordModal(user)"
                    class="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-700 transition">
                    Modifică Parola
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>
      <!-- Footer -->
      <FooterComponent />
    </div>

    <!-- Modal pentru creare cont -->
    <div v-if="isCreateModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-card-welcome p-6 rounded-lg shadow-lg w-96">
        <h2 class="text-xl font-bold text-accent-light mb-4">Creează Cont</h2>
        <div class="space-y-4">
          <div>
            <label class="block text-sm mb-1" for="username">Username:</label>
            <input id="username" v-model="newUser.username" type="text"
              class="w-full px-3 py-2 rounded bg-sidebar-dark text-white" />
          </div>
          <div>
            <label class="block text-sm mb-1" for="password">Password:</label>
            <input id="password" v-model="newUser.password" type="password"
              class="w-full px-3 py-2 rounded bg-sidebar-dark text-white" />
          </div>
          <div>
            <label class="block text-sm mb-1" for="passwordConfirmation">Password Confirmation:</label>
            <input id="passwordConfirmation" v-model="newUser.passwordConfirmation" type="password"
              class="w-full px-3 py-2 rounded bg-sidebar-dark text-white" />
          </div>
          <div>
            <label class="block text-sm mb-1" for="role">Grad:</label>
            <select id="role" v-model="newUser.role" class="w-full px-3 py-2 rounded bg-sidebar-dark text-white">
              <option value="User">User</option>
              <option value="Owner">Owner</option>
            </select>
          </div>
          <div class="flex justify-end space-x-2">
            <button @click="createUser"
              class="bg-accent-light text-white font-bold py-2 px-4 rounded hover:bg-accent-dark transition">
              Creează
            </button>
            <button @click="closeCreateModal"
              class="bg-gray-500 text-white font-bold py-2 px-4 rounded hover:bg-gray-700 transition">
              Anulează
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal pentru modificare parolă -->
    <div v-if="isChangePasswordModalOpen"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-card-welcome p-6 rounded-lg shadow-lg w-96">
        <h2 class="text-xl font-bold text-accent-light mb-4">Modifică Parola</h2>
        <div class="space-y-4">
          <div>
            <label class="block text-sm mb-1" for="newPassword">Parolă nouă:</label>
            <input id="newPassword" v-model="passwordChange.newPassword" type="password"
              class="w-full px-3 py-2 rounded bg-sidebar-dark text-white" />
          </div>
          <div>
            <label class="block text-sm mb-1" for="confirmPassword">Confirmare parolă:</label>
            <input id="confirmPassword" v-model="passwordChange.confirmPassword" type="password"
              class="w-full px-3 py-2 rounded bg-sidebar-dark text-white" />
          </div>
          <div class="flex justify-end space-x-2">
            <button @click="changePassword"
              class="bg-accent-light text-white font-bold py-2 px-4 rounded hover:bg-accent-dark transition">
              Modifică
            </button>
            <button @click="closeChangePasswordModal"
              class="bg-gray-500 text-white font-bold py-2 px-4 rounded hover:bg-gray-700 transition">
              Anulează
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterComponent from "@/components/FooterComponent.vue";
import SidebarComponent from "../components/SidebarComponent.vue";
import apiClient from "@/api/axiosInstance"; // Importăm instanța Axios configurată

export default {
  name: "ConturiView",
  components: {
    SidebarComponent,
    FooterComponent,
  },
  data() {
    return {
      users: [],
      isCreateModalOpen: false,
      isChangePasswordModalOpen: false,
      selectedUserId: null,
      newUser: {
        username: "",
        password: "",
        passwordConfirmation: "",
        role: "User",
      },
      passwordChange: {
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  methods: {
    async fetchUsers() {
      try {
        const response = await apiClient.get("/api/users", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.users = response.data;
      } catch (error) {
        console.error("Eroare la încărcarea utilizatorilor:", error);
        alert("Nu s-au putut încărca utilizatorii.");
      }
    },
    openCreateModal() {
      this.isCreateModalOpen = true;
    },
    closeCreateModal() {
      this.isCreateModalOpen = false;
      this.newUser = { username: "", password: "", passwordConfirmation: "", role: "User" };
    },
    async createUser() {
      if (this.newUser.password !== this.newUser.passwordConfirmation) {
        alert("Parolele nu se potrivesc!");
        return;
      }

      try {
        await apiClient.post("/api/users", this.newUser, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.fetchUsers();
        this.closeCreateModal();
      } catch (error) {
        console.error("Eroare la crearea utilizatorului:", error);
        alert("Nu s-a putut crea utilizatorul.");
      }
    },
    async deleteUser(userId) {
      try {
        await apiClient.delete(`/api/users/${userId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.fetchUsers();
      } catch (error) {
        console.error("Eroare la ștergerea utilizatorului:", error);
        alert("Nu s-a putut șterge utilizatorul.");
      }
    },
    openChangePasswordModal(user) {
      this.selectedUserId = user.id;
      this.isChangePasswordModalOpen = true;
      this.passwordChange = { newPassword: "", confirmPassword: "" };
    },
    closeChangePasswordModal() {
      this.isChangePasswordModalOpen = false;
      this.passwordChange = { newPassword: "", confirmPassword: "" };
    },
    async changePassword() {
      if (this.passwordChange.newPassword !== this.passwordChange.confirmPassword) {
        alert("Parolele nu se potrivesc!");
        return;
      }

      try {
        await apiClient.patch(`/api/users/${this.selectedUserId}/password`, {
          password: this.passwordChange.newPassword,
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.closeChangePasswordModal();
        alert("Parola a fost modificată cu succes!");
      } catch (error) {
        console.error("Eroare la modificarea parolei:", error);
        alert("Nu s-a putut modifica parola.");
      }
    },
  },
  mounted() {
    this.fetchUsers();
  },
};
</script>

<style scoped>
.bg-card-welcome {
  background-color: #1a1528;
}

.hover\:bg-hover-dark:hover {
  background-color: #262642;
}

.text-sm {
  font-size: 0.875rem;
}
</style>
